import Vue from 'vue'
import store from './store'
import VueGridLayoutDesigner from '@/plugins/vue-grid-layout-designer/main.js'
import VueYoastSeo from '@/plugins/vue-yoast-seo/main.js'

Vue.use(VueGridLayoutDesigner, store)
Vue.use(VueYoastSeo)
